var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-1",attrs:{"fluid":""}},[_c('v-card',{attrs:{"dark":""}},[_c('v-card-title',{attrs:{"primary-title":""}},[_vm._v(_vm._s(_vm.title))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }